import { render } from "./Oscars.vue?vue&type=template&id=37c3625c"
import script from "./Oscars.vue?vue&type=script&lang=js"
export * from "./Oscars.vue?vue&type=script&lang=js"

import "./Oscars.vue?vue&type=style&index=0&id=37c3625c&lang=css"

import exportComponent from "D:\\Hobby\\Javascript\\Sito_AS\\aperispeak\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__